import { render } from "./About.vue?vue&type=template&id=65fc84f2&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=65fc84f2&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc84f2"]])

export default __exports__